import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { SubSubGroupForm } from "@univdiam/ui/customComponents/SubSubGroupList/SubSubGroupForm"
// import api from '@/http/api'
import axios from "axios"

const API_BASE_URL = import.meta.env.VITE_SERVER_URL

export default function EditSubSubGroup() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [initialData, setInitialData] = useState(null)
  const [groupData, setGroupData] = useState(null)

  useEffect(() => {
    const fetchSubSubGroup = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/sub_sub_groups/${id}`)
        if (response.status === 200 && response.data) {
          const group = response.data.data
          console.log(group)
          // Map fields to your form shape
          setInitialData({
            sub_sub_group_id: group.sub_sub_group_id,
            sub_group_id: group.sub_group_id,
            name: group.name,
            code: group.code,
            status: group.status === 1 ? "1" : "0"  
          })
        }
      } catch (err) {
        console.error("Failed to fetch group", err)
        navigate("/sub-sub-group")
      }
    }

    const fetchGroup = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/sub_groups`)
        if (response.status === 200 && response.data) {
          const group = response.data.data
          // Map fields to your form shape
          const transformed = group.map((group: any) => ({
            sub_group_id: group.sub_group_id,
            name: group.name,
            status: group.status === 1 ? "Enabled" : "Disabled"
          }))
          setGroupData(transformed)
        }
      } catch (err) {
        console.error("Failed to fetch group", err)
        navigate("/sub-sub-group")
      }
    }

    fetchSubSubGroup()
    fetchGroup()
  }, [id, navigate])

  const handleUpdateSubSubGroup = async (data: any) => {
    try {
      const response = await axios.put(`${API_BASE_URL}/api/sub_sub_groups/${id}`, data)
      if (response.status === 200) {
        alert("SubSubGroup updated successfully!")
        navigate("/sub-sub-group")
      }
    } catch (error) {
      console.error("Error updating group:", error)
      alert("Failed to update group.")
    }
  }

  if (!initialData) return <p className="text-center p-10">Loading...</p>

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Edit Sub Sub Group</h1>
      <SubSubGroupForm onSubmit={handleUpdateSubSubGroup} initialValues={initialData} groupValues={groupData} isEdit />
    </div>
  )
}
